const WAITLIST_COOKIE_NAME = "fm_waitlist";
const COOKIE_MAX_AGE_DAYS = 365; // 1 year

/**
 * Set a client-side cookie
 */
const setClientCookie = (name: string, value: string, days: number): void => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

/**
 * Get a client-side cookie
 */
const getClientCookie = (name: string): string | null => {
  const value = document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
  return value || null;
};

/**
 * Check if user is on waitlist (client-side)
 */
export const checkWaitlistStatus = (): boolean => {
  /* v8 ignore next -- @preserve SSR check */
  if (typeof document === "undefined") return false;
  const cookie = getClientCookie(WAITLIST_COOKIE_NAME);
  return cookie === "joined";
};

/**
 * Mark user as joined waitlist (client-side)
 */
export const markWaitlistJoined = (): void => {
  /* v8 ignore next -- @preserve SSR check */
  if (typeof document === "undefined") return;
  setClientCookie(WAITLIST_COOKIE_NAME, "joined", COOKIE_MAX_AGE_DAYS);
};
